import UrlUtil from "./url-config";
import {BusinessUtil} from "../utils/BusinessUtil";

const UA = localStorage.getItem('wkData-webUA') || window.navigator.userAgent;
const CheckUtil = {
    // 判断规格价格是否一样
    isSamePrice(productList=[]) {
        let targetPro = productList[0];
        let isSamePrice = true;
        productList.forEach(pro => {
            if ((BusinessUtil.isLogin() && targetPro.client_price_ !== pro.client_price_) || (!BusinessUtil.isLogin() && targetPro.market_price_ !== pro.market_price_)) {
                isSamePrice = false;
            }
        });
        return isSamePrice;
    },
    // 判断规格零售价价格是否一样
    isSameMarketPrice(productList=[]) {
        let targetPro = productList[0];
        let isSamePrice = true;
        productList.forEach(pro => {
            if ((!BusinessUtil.isLogin() && targetPro.market_price_ !== pro.market_price_)) {
                isSamePrice = false;
            }
        });
        return isSamePrice;
    },
    //检查账号
    isAccount() {
        return /^([a-zA-Z0-9]|[@._]){6,20}$/.test(v);
    },
    //检查密码
    isPassword(v) {
        return /^([a-zA-Z0-9]|[@._]){6,20}$/.test(v);
    },
    //是否数字
    isNumber: function (value) {
        return !isNaN(value);
    },
    //是否两位小数
    isTwoDecNumber(v) {
        return /^\d{0,8}\.{0,1}(\d{1,2})?$/.test(v);
    },
    //是否Emoji表情
    hasEmoji(v) {
        return /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83C[\uDC00-\uDFFF]/g.test(v);
    },
    //保留两位小数
    twoDecNumber(num) {
        num = num.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
        num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
        if (num.indexOf(".") < 0 && num != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            num = parseFloat(num);
        }
        if (num === '.') {
            num = 0
        }
        return num;
    },
    //检查体验企业
    isExperience: companyId => {
        const experienceCompanyIds = [118, 729, 724, 121, 128, 117, 124, 116, 119, 122, 123, 725];
        let isExperience = false;
        experienceCompanyIds.forEach(item => {
            if (item == companyId) {
                isExperience = true;
            }
        });
        return isExperience;
    },
    //是否对象
    isObject: function (obj) {
        return obj !== null && typeof obj === 'object';
    },
    //是否空对象
    isEmptyObject: function (obj) {
        for (let key in obj) {
            return false;
        }
        return true;
    },
    //是否数组
    isArray: function (obj) {
        return Array.isArray(obj);
    },
    //是否是空
    isNull: function (arg) {
        return (!arg && arg !== 0 && typeof arg !== 'undefined')
    },
    //检查是否空
    isUndefind: function (v) {
        return v == undefined
    },
    //验证手机
    isPhone: (phone) => {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
            return false;
        } else {
            return true;
        }
    },

    //校验url格式
    isUrl: (v) => {
        return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(v)
    },
    //校验邮箱格式
    isEmail: (v) => {
        return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v)
    },

    isEqualObj: (objA, objB) => {
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
            return false;
        }
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
            return false;
        }
        for (let key in objA) {
            if (objA[key] !== objB[key]) {
                return false
            }
        }
        return true;
    },
    isRealNumber: function (str) {
        // 使用正则表达式匹配数字的模式
        const pattern = /^[0-9]+(\.[0-9]+)?$/;
        // 判断字符串是否匹配数字的模式
        return pattern.test(str);
    },
    //是否安卓
    isAndroid: (UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1 || UA.indexOf('android') > -1),
    //是否IOS
    isIos: (UA.indexOf('iphone') > -1 || UA.indexOf('mac') > -1 || UA.indexOf('iPhone') > -1),
    //是否手机
    isMobile: UA.match(/(iPhone|iPod|Android|ios)/i),
    //是否微信
    isWeiXin: /micromessenger/.test(UA.toLowerCase()),
    isSafari: (UA.indexOf("Safari") > -1 && UA.indexOf("Chrome") < 0),
    //是否小程序
    isMiniProgram: window.__wxjs_environment == 'miniprogram',
    //是否第二正式环境
    isSecondUrl: window.location.href.indexOf(`am.${UrlUtil.getHost()}.com`) > -1,
    //是否第三正式环境
    isThirdUrl: window.location.href.indexOf(`bm.${UrlUtil.getHost()}.com`) > -1

};

export default CheckUtil;



// WEBPACK FOOTER //
// ./src/utils/check-util.js